import { type TChatbotNode } from './node.type'
import { type Edge } from '@xyflow/react'

// ID generation pattern recommended by ReactFlow documentation
// https://reactflow.dev/examples/nodes/add-node-on-edge-drop
export const createIdGenerators = () => {
  let nodeIdCounter = 1
  let edgeIdCounter = 1

  return {
    getNodeId: () => `node-${nodeIdCounter++}`,
    getEdgeId: () => `edge-${edgeIdCounter++}`,
    initializeCounters: (nodes: TChatbotNode[], edges: Edge[]) => {
      // Extract the highest node number from existing IDs (e.g., "node-5" -> 5)
      const maxNodeId = nodes.reduce((max, node) => {
        const match = /^node-(\d+)$/.exec(node.id)
        return match ? Math.max(max, Number.parseInt(match[1]!, 10)) : max
      }, 0)
      nodeIdCounter = maxNodeId + 1

      // Same for edges
      const maxEdgeId = edges.reduce((max, edge) => {
        const match = /^edge-(\d+)$/.exec(edge.id)
        return match ? Math.max(max, Number.parseInt(match[1]!, 10)) : max
      }, 0)
      edgeIdCounter = maxEdgeId + 1
    },
  }
}
